'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var RescriptReactRouter = require("@rescript/react/lib/js/src/RescriptReactRouter.js");

function Link(Props) {
  var href = Props.href;
  var className = Props.className;
  var children = Props.children;
  var doHandleClickOpt = Props.doHandleClick;
  var onClick = Props.onClick;
  var doHandleClick = doHandleClickOpt !== undefined ? doHandleClickOpt : true;
  if (doHandleClick) {
    var tmp = {
      href: href,
      onClick: (function (param) {
          param.preventDefault();
          RescriptReactRouter.push(href);
          if (onClick !== undefined) {
            return Curry._1(onClick, param);
          }
          
        })
    };
    if (className !== undefined) {
      tmp.className = Caml_option.valFromOption(className);
    }
    return React.createElement("a", tmp, children);
  }
  if (onClick !== undefined) {
    var tmp$1 = {
      href: href,
      onClick: onClick
    };
    if (className !== undefined) {
      tmp$1.className = Caml_option.valFromOption(className);
    }
    return React.createElement("a", tmp$1, children);
  }
  var tmp$2 = {
    href: href
  };
  if (className !== undefined) {
    tmp$2.className = Caml_option.valFromOption(className);
  }
  return React.createElement("a", tmp$2, children);
}

function makeProps(prim0, prim1, prim2, prim3, prim4, prim5, prim6) {
  var tmp = {
    href: prim0,
    children: prim2
  };
  if (prim1 !== undefined) {
    tmp.className = Caml_option.valFromOption(prim1);
  }
  if (prim3 !== undefined) {
    tmp.doHandleClick = Caml_option.valFromOption(prim3);
  }
  if (prim4 !== undefined) {
    tmp.onClick = Caml_option.valFromOption(prim4);
  }
  if (prim5 !== undefined) {
    tmp.key = prim5;
  }
  return tmp;
}

var make = Link;

exports.makeProps = makeProps;
exports.make = make;
/* react Not a pure module */
